module.exports = __webpack_public_path__ + "img/pinata.50833893.png";